import { Actions } from '../constants/Actions';
import { RelationshipActions } from '../constants/RelationshipActions';

export const DASHBOARD_PERMISSIONS = {
  MANAGE: `dashboard:${Actions.MANAGE}`,
  VIEW: `dashboard:${Actions.VIEW}`,
  CREATE: `dashboard:${Actions.CREATE}`,
  UPDATE: `dashboard:${Actions.UPDATE}`,
  DELETE: `dashboard:${Actions.DELETE}`,
  PUBLISH: `dashboard:${Actions.PUBLISH}`,
  UNPUBLISH: `dashboard:${Actions.UNPUBLISH}`,
  CLONE: `dashboard:${Actions.CLONE}`,
  EXPORT: `dashboard:${Actions.EXPORT}`,
  IMPORT: `dashboard:${Actions.IMPORT}`,
  SHARE: `dashboard:${Actions.SHARE}`,
  EXECUTE: `dashboard:${Actions.EXECUTE}`,
  SCHEDULE: 'dashboard:schedule',
  ARCHIVE: `dashboard:${Actions.ARCHIVE}`,
  ASSIGN_TENANT: `dashboard:${RelationshipActions.ASSIGN_TENANT}`,
};
